var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _g2, _path8, _path9, _g3, _path0, _path1, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNoData2 = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 141,
    viewBox: "0 0 160 141",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9178 119.855C107.053 119.855 129.051 97.8562 129.051 70.6244C129.051 43.3925 107.053 21.3938 79.9178 21.3938C52.7829 21.3938 30.7842 43.3925 30.7842 70.6244C30.7842 97.8562 52.7829 119.855 79.9178 119.855Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.673 50.3698C136.867 50.3698 138.646 48.5908 138.646 46.3964C138.646 44.202 136.867 42.4231 134.673 42.4231C132.478 42.4231 130.699 44.202 130.699 46.3964C130.699 48.5908 132.478 50.3698 134.673 50.3698Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.486 34.7681C141.985 34.7681 143.199 33.5532 143.199 32.0546C143.199 30.5559 141.985 29.3411 140.486 29.3411C138.987 29.3411 137.772 30.5559 137.772 32.0546C137.772 33.5532 138.987 34.7681 140.486 34.7681Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3922 53.1821C28.8908 53.1821 30.1057 51.9672 30.1057 50.4686C30.1057 48.97 28.8908 47.7551 27.3922 47.7551C25.8936 47.7551 24.6787 48.97 24.6787 50.4686C24.6787 51.9672 25.8936 53.1821 27.3922 53.1821Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4309 112.199C35.2141 112.199 37.4703 109.943 37.4703 107.16C37.4703 104.377 35.2141 102.12 32.4309 102.12C29.6478 102.12 27.3916 104.377 27.3916 107.16C27.3916 109.943 29.6478 112.199 32.4309 112.199Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9740_90266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.465 50.9526H41.4434C39.6021 50.9526 38.1484 49.4989 38.1484 47.6576V28.76C38.1484 26.9187 39.6021 25.4651 41.4434 25.4651H125.368C127.209 25.4651 128.663 26.9187 128.663 28.76V47.6576C128.76 49.4989 127.209 50.9526 125.465 50.9526Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9817 36.0283H46.3749C45.8903 36.0283 45.5996 35.6406 45.5996 35.253V32.8302C45.5996 32.3457 45.9873 32.0549 46.3749 32.0549H64.9817C65.4663 32.0549 65.757 32.4426 65.757 32.8302V35.253C65.757 35.7375 65.4663 36.0283 64.9817 36.0283Z",
    fill: "#CED6E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0773 44.2665H46.3749C45.8903 44.2665 45.5996 43.8789 45.5996 43.4913V41.0685C45.5996 40.5839 45.9873 40.2932 46.3749 40.2932H87.0773C87.5619 40.2932 87.8526 40.6809 87.8526 41.0685V43.4913C87.8526 43.9758 87.465 44.2665 87.0773 44.2665Z",
    fill: "#CED6E2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9740_90266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.466 114.524H41.4444C39.6031 114.524 38.1494 113.07 38.1494 111.229V92.3313C38.1494 90.49 39.6031 89.0364 41.4444 89.0364H125.369C127.21 89.0364 128.664 90.49 128.664 92.3313V111.229C128.761 113.07 127.21 114.524 125.466 114.524Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9827 99.6979H46.3759C45.8913 99.6979 45.6006 99.3103 45.6006 98.9227V96.4999C45.6006 96.0153 45.9882 95.7246 46.3759 95.7246H64.9827C65.4672 95.7246 65.758 96.1123 65.758 96.4999V98.9227C65.758 99.3103 65.4672 99.6979 64.9827 99.6979Z",
    fill: "#CED6E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0783 107.936H46.3759C45.8913 107.936 45.6006 107.549 45.6006 107.161V104.738C45.6006 104.254 45.9882 103.963 46.3759 103.963H87.0783C87.5629 103.963 87.8536 104.351 87.8536 104.738V107.161C87.8536 107.549 87.4659 107.936 87.0783 107.936Z",
    fill: "#CED6E2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9740_90266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.219 82.7375H27.295C25.4537 82.7375 24 81.2838 24 79.4425V60.545C24 58.7037 25.4537 57.25 27.295 57.25H111.219C113.061 57.25 114.514 58.7037 114.514 60.545V79.4425C114.611 81.2838 113.061 82.7375 111.219 82.7375Z",
    fill: "white"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5823 67.8139H31.9755C31.4909 67.8139 31.2002 67.4263 31.2002 67.0386V64.6159C31.2002 64.1313 31.5878 63.8406 31.9755 63.8406H50.5823C51.0669 63.8406 51.3576 64.2282 51.3576 64.6159V67.0386C51.3576 67.5232 51.0669 67.8139 50.5823 67.8139Z",
    fill: "#CED6E2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6779 76.1479H31.9755C31.4909 76.1479 31.2002 75.7603 31.2002 75.3726V72.9498C31.2002 72.4653 31.5878 72.1746 31.9755 72.1746H72.581C73.0656 72.1746 73.3563 72.5622 73.3563 72.9498V75.3726C73.4532 75.7603 73.0656 76.1479 72.6779 76.1479Z",
    fill: "#CED6E2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9740_90266",
    x: 29.1484,
    y: 21.4651,
    width: 108.519,
    height: 43.4875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9740_90266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9740_90266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9740_90266",
    x: 29.1494,
    y: 85.0364,
    width: 108.519,
    height: 43.4875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9740_90266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9740_90266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9740_90266",
    x: 15,
    y: 53.25,
    width: 108.519,
    height: 43.4875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9740_90266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9740_90266",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoData2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no-data-2.171d29c3.svg";
export { ForwardRef as ReactComponent };